/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PaginationDto } from '../models/pagination-dto';
import { reviewControllerCreate } from '../fn/review/review-controller-create';
import { ReviewControllerCreate$Params } from '../fn/review/review-controller-create';
import { reviewControllerDelete } from '../fn/review/review-controller-delete';
import { ReviewControllerDelete$Params } from '../fn/review/review-controller-delete';
import { reviewControllerFindAll } from '../fn/review/review-controller-find-all';
import { ReviewControllerFindAll$Params } from '../fn/review/review-controller-find-all';
import { reviewControllerFindById } from '../fn/review/review-controller-find-by-id';
import { ReviewControllerFindById$Params } from '../fn/review/review-controller-find-by-id';
import { reviewControllerSearch } from '../fn/review/review-controller-search';
import { ReviewControllerSearch$Params } from '../fn/review/review-controller-search';
import { reviewControllerSearchMyReview } from '../fn/review/review-controller-search-my-review';
import { ReviewControllerSearchMyReview$Params } from '../fn/review/review-controller-search-my-review';
import { reviewControllerToggleIsShown } from '../fn/review/review-controller-toggle-is-shown';
import { ReviewControllerToggleIsShown$Params } from '../fn/review/review-controller-toggle-is-shown';
import { reviewControllerUpdate } from '../fn/review/review-controller-update';
import { ReviewControllerUpdate$Params } from '../fn/review/review-controller-update';
import { ReviewDto } from '../models/review-dto';

@Injectable({ providedIn: 'root' })
export class ReviewService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reviewControllerSearch()` */
  static readonly ReviewControllerSearchPath = '/api/v1/review/search';

  /**
   * review 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerSearch$Response(params: ReviewControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginationDto>> {
    return reviewControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * review 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerSearch(params: ReviewControllerSearch$Params, context?: HttpContext): Observable<PaginationDto> {
    return this.reviewControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginationDto>): PaginationDto => r.body)
    );
  }

  /** Path part for operation `reviewControllerSearchMyReview()` */
  static readonly ReviewControllerSearchMyReviewPath = '/api/v1/review/search-my-review';

  /**
   * 나의 예약 목록 검색 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewControllerSearchMyReview()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerSearchMyReview$Response(params: ReviewControllerSearchMyReview$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginationDto>> {
    return reviewControllerSearchMyReview(this.http, this.rootUrl, params, context);
  }

  /**
   * 나의 예약 목록 검색 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewControllerSearchMyReview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerSearchMyReview(params: ReviewControllerSearchMyReview$Params, context?: HttpContext): Observable<PaginationDto> {
    return this.reviewControllerSearchMyReview$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginationDto>): PaginationDto => r.body)
    );
  }

  /** Path part for operation `reviewControllerFindAll()` */
  static readonly ReviewControllerFindAllPath = '/api/v1/review';

  /**
   * 모든 review 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerFindAll$Response(params?: ReviewControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReviewDto>>> {
    return reviewControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 review 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerFindAll(params?: ReviewControllerFindAll$Params, context?: HttpContext): Observable<Array<ReviewDto>> {
    return this.reviewControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReviewDto>>): Array<ReviewDto> => r.body)
    );
  }

  /** Path part for operation `reviewControllerCreate()` */
  static readonly ReviewControllerCreatePath = '/api/v1/review';

  /**
   * review 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewControllerCreate$Response(params: ReviewControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
    return reviewControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * review 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewControllerCreate(params: ReviewControllerCreate$Params, context?: HttpContext): Observable<ReviewDto> {
    return this.reviewControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReviewDto>): ReviewDto => r.body)
    );
  }

  /** Path part for operation `reviewControllerFindById()` */
  static readonly ReviewControllerFindByIdPath = '/api/v1/review/{id}';

  /**
   * review id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerFindById$Response(params: ReviewControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
    return reviewControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * review id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerFindById(params: ReviewControllerFindById$Params, context?: HttpContext): Observable<ReviewDto> {
    return this.reviewControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReviewDto>): ReviewDto => r.body)
    );
  }

  /** Path part for operation `reviewControllerDelete()` */
  static readonly ReviewControllerDeletePath = '/api/v1/review/{id}';

  /**
   * review 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerDelete$Response(params: ReviewControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reviewControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * review 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerDelete(params: ReviewControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.reviewControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reviewControllerUpdate()` */
  static readonly ReviewControllerUpdatePath = '/api/v1/review/{id}';

  /**
   * review 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewControllerUpdate$Response(params: ReviewControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
    return reviewControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * review 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reviewControllerUpdate(params: ReviewControllerUpdate$Params, context?: HttpContext): Observable<ReviewDto> {
    return this.reviewControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReviewDto>): ReviewDto => r.body)
    );
  }

  /** Path part for operation `reviewControllerToggleIsShown()` */
  static readonly ReviewControllerToggleIsShownPath = '/api/v1/review/{id}/toggle-is-shown';

  /**
   * 리뷰 노출 여부 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewControllerToggleIsShown()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerToggleIsShown$Response(params: ReviewControllerToggleIsShown$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
    return reviewControllerToggleIsShown(this.http, this.rootUrl, params, context);
  }

  /**
   * 리뷰 노출 여부 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reviewControllerToggleIsShown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewControllerToggleIsShown(params: ReviewControllerToggleIsShown$Params, context?: HttpContext): Observable<ReviewDto> {
    return this.reviewControllerToggleIsShown$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReviewDto>): ReviewDto => r.body)
    );
  }

}
